<template>
    <dash icon="fa fa-info-circle" titulo="DADOS CADASTRAIS" @click.native="$router.push(rota)"></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
	props: {
		rota: {
			type: Object,
			default: () => ({
				name: 'FornecedorDadosCadastrais'
			})
		}
	},

	components: {
		Dash
	},

	data() {
		return {}
	}
}
</script>
